import { STAGES, STATUSES, STAGE_COLORS } from '../utils/constants';
import Step from './common/Step';
import { IRequestInfo } from '../types/requester';
import { getDateAndTime } from '../utils/commonUtils';

interface StagesStepperProps {
    data: IRequestInfo | null;
}

const StagesStepper = ({ data }: StagesStepperProps) => {
    return (
        <div className="req-gen-steps">
            {Object.keys(STAGES).map((stage, index) => {
                const subTitle = data?.stage === stage ? STATUSES[data?.status || ''] : '';
                const updatedDate = data?.stage === stage ? getDateAndTime(data.updatedAt) : '';
                const indexOfActiveStage: number = Object.keys(STAGES).indexOf(data?.stage || '');
                return <Step title={STAGES[stage]} subTitle={subTitle} tagText={updatedDate} color={STAGE_COLORS[stage]} isActive={data?.stage === stage} isDisabled={index < indexOfActiveStage} />;
            })}
        </div>
    );
};

export default StagesStepper;
